(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2948],{

/***/ 7419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74251);
/* harmony import */ var _SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var SectionLayout = function(param) {
    var children = param.children, sectionName = param.sectionName, sectionImage = param.sectionImage, sectionImageAlt = param.sectionImageAlt, title = param.title, style = param.style, titleStyle = param.titleStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "".concat((_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default().section), " ").concat((_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[sectionName], " ").concat(style ? style : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default().sectionHeading),
                children: [
                    sectionImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: sectionImage,
                        alt: sectionImageAlt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "".concat((_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default().sectionHeadingTitle), " ").concat((_SectionLayout_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[sectionName], "Title ").concat(titleStyle ? titleStyle : ""),
                        children: title
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionLayout);


/***/ }),

/***/ 18074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var hooks_common_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16529);
/* harmony import */ var _AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65025);
/* harmony import */ var _AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2__);

// hooks

// style

var PlaceAreaList = function(param) {
    var places = param.places, countryCode = param.countryCode, prefectureSlug = param.prefectureSlug, locale = param.locale;
    var getName = function(locale, info) {
        var ref;
        return locale === "ja" ? info.name : (ref = info["".concat(locale, "_name")]) !== null && ref !== void 0 ? ref : info.name;
    };
    // 言語の修正
    var replacedLocale = (0,hooks_common_lang__WEBPACK_IMPORTED_MODULE_1__/* .replaceLocale */ .mC)(locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaList),
        children: places && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: places.map(function(place, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaListItem),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/".concat(replacedLocale, "/").concat(countryCode, "/city/").concat(prefectureSlug, "/").concat(place.id),
                        children: getName(locale, place)
                    })
                }, index);
            })
        })
    });
};
var AreaPlaceList = function(param) {
    var prefectureSlug = param.prefectureSlug, places = param.places, label = param.label, countryCode = param.countryCode, locale = param.locale, headingStyle = param.headingStyle;
    // 見出しのスタイル一覧
    var headingStyles = [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: headingStyle && headingStyles.includes(headingStyle) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeArea),
            children: [
                headingStyle === "h1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                headingStyle === "h2" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                headingStyle === "h3" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                headingStyle === "h4" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                headingStyle === "h5" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                headingStyle === "h6" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaListWrap),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlaceAreaList, {
                        places: places,
                        countryCode: countryCode,
                        prefectureSlug: prefectureSlug,
                        locale: locale
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
            className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeArea),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaTitle),
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                    className: (_AreaPlaceList_module_scss__WEBPACK_IMPORTED_MODULE_2___default().placeAreaListWrap),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlaceAreaList, {
                        places: places,
                        countryCode: countryCode,
                        prefectureSlug: prefectureSlug,
                        locale: locale
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AreaPlaceList);


/***/ }),

/***/ 68082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28908);
/* harmony import */ var _AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_common_lang__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16529);
// react




// hooks

var AreaPrefectureList = function(param) {
    var areaName = param.areaName, prefectures = param.prefectures, locale = param.locale, onSelectAreaName = param.onSelectAreaName, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    // 言語の修正
    var replacedLocale = (0,hooks_common_lang__WEBPACK_IMPORTED_MODULE_3__/* .replaceLocale */ .mC)(locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: countryCode === "twn" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: (prefectures === null || prefectures === void 0 ? void 0 : prefectures.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaList),
                children: prefectures.map(function(prefecture, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaListItem),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/".concat(replacedLocale, "/twn/city/").concat(prefecture.slug),
                            legacyBehavior: true,
                            children: prefecture.name
                        })
                    }, index);
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
            className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefArea),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dt", {
                    className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaTitle),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaTitleText),
                            children: areaName
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaTitleIcon),
                            onClick: function() {
                                setIsOpen(!isOpen);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "".concat((_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaArrowImage), " ").concat(isOpen ? (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaArrowImageActive) : ""),
                                src: "/arrow_bottom_black.svg",
                                alt: "arrow_down"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                    className: "".concat((_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaListWrap), " ").concat(isOpen ? (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaListWrapActive) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaList),
                        children: (prefectures === null || prefectures === void 0 ? void 0 : prefectures.length) > 0 && prefectures.map(function(prefecture, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: (_AreaPrefectureList_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefAreaListItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/".concat(replacedLocale, "/jpn/city/").concat(prefecture.slug),
                                    onClick: function(e) {
                                        if (onSelectAreaName) {
                                            e.preventDefault();
                                            onSelectAreaName(prefecture);
                                        }
                                    },
                                    children: prefecture.name
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AreaPrefectureList);


/***/ }),

/***/ 59658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cp": function() { return /* binding */ getPrefectureCountryId; },
/* harmony export */   "tP": function() { return /* binding */ JP_COUNTRY_ID; }
/* harmony export */ });
/* unused harmony export TW_COUNTRY_ID */
var JP_COUNTRY_ID = 1050;
var TW_COUNTRY_ID = 2000;
var getPrefectureCountryId = function(countryCode) {
    var normalizedCountryCode = Array.isArray(countryCode) ? countryCode[0] : countryCode;
    return (normalizedCountryCode === null || normalizedCountryCode === void 0 ? void 0 : normalizedCountryCode.toLowerCase()) === "twn" ? TW_COUNTRY_ID : JP_COUNTRY_ID;
};


/***/ }),

/***/ 55213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ usePrefectures; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./src/lib/axios.ts
var lib_axios = __webpack_require__(61969);
// EXTERNAL MODULE: ./node_modules/axios-cache-interceptor/dist/index.modern.js + 3 modules
var index_modern = __webpack_require__(99376);
// EXTERNAL MODULE: ./src/features/prefecture/constants.ts
var constants = __webpack_require__(59658);
;// CONCATENATED MODULE: ./src/features/prefecture/services/prefectureAreasApi.ts






var API_PREFECTURES = "/api/web/prefectures";
var PREFECTURE_AREAS_CACHE_TTL = 24 * 60 * 60 * 1000;
// Dedicated instance so setupCache does not affect shared ecboClient GETs (e.g. available_items).
var cachedPrefectureAreasClient = (0,index_modern/* setupCache */.v8)(axios/* default.create */.Z.create(lib_axios/* ecboClient.defaults */.ZK.defaults), {
    interpretHeader: false
});
var getPrefectureAreasCacheId = function(acceptLanguage, countryId) {
    return "prefecture-areas:".concat(acceptLanguage, ":").concat(countryId);
};
var fetchPrefectureAreas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var locale, _countryId, countryId, acceptLanguage, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = param.locale, _countryId = param.countryId, countryId = _countryId === void 0 ? constants/* JP_COUNTRY_ID */.tP : _countryId;
                    acceptLanguage = (0,lib_axios/* getHeaderLocale */.hi)(locale);
                    return [
                        4,
                        cachedPrefectureAreasClient.get(API_PREFECTURES, {
                            params: {
                                country_id: countryId
                            },
                            headers: {
                                "Accept-Language": acceptLanguage
                            },
                            id: getPrefectureAreasCacheId(acceptLanguage, countryId),
                            cache: {
                                ttl: PREFECTURE_AREAS_CACHE_TTL
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            isOk: true,
                            data: response.data
                        }
                    ];
            }
        });
    });
    return function fetchPrefectureAreas(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/prefecture/hooks/usePrefectures.ts








var usePrefectures = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _countryId = ref.countryId, countryId = _countryId === void 0 ? constants/* JP_COUNTRY_ID */.tP : _countryId, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref1 = (0,react.useState)(null), prefectures = ref1[0], setPrefectures = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var fetchPrefectures = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!countryId) return [
                        2
                    ];
                    setLoading(true);
                    setIsError(false);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetchPrefectureAreas({
                            locale: i18n.language,
                            countryId: countryId
                        })
                    ];
                case 2:
                    data = _state.sent().data;
                    setPrefectures(data);
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    setIsError(true);
                    esm_exports/* captureException */.Tb((0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)), {
                        tags: {
                            hook: "usePrefectures"
                        },
                        extra: {
                            locale: i18n.language,
                            countryId: countryId
                        }
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        countryId,
        i18n.language
    ]);
    (0,react.useEffect)(function() {
        if (!enabled) return;
        fetchPrefectures();
    }, [
        enabled,
        fetchPrefectures
    ]);
    return {
        prefectures: prefectures,
        isLoading: isLoading,
        isError: isError,
        fetchPrefectures: fetchPrefectures
    };
};


/***/ }),

/***/ 60966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useCustomIntercom; }
/* harmony export */ });
/* harmony import */ var react_use_intercom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41608);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);


function useCustomIntercom() {
    var ref = (0,react_use_intercom__WEBPACK_IMPORTED_MODULE_1__/* .useIntercom */ .o)(), boot = ref.boot, showNewMessage = ref.showNewMessage;
    var openIntercomMessage = function(isShowNewMessage, account) {
        if (account) {
            boot({
                email: account.email,
                name: account.name,
                phone: account.phone,
                userId: account.userId,
                createdAt: String(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().unix())
            });
        } else {
            boot({
                createdAt: String(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().unix())
            });
        }
        if (isShowNewMessage) {
            showNewMessage();
        }
    };
    return {
        openIntercomMessage: openIntercomMessage
    };
}


/***/ }),

/***/ 74251:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","section":"SectionLayout_section__LgiNS","sectionHeading":"SectionLayout_sectionHeading__jz50S","sectionHeadingTitle":"SectionLayout_sectionHeadingTitle__T6mOc","usage":"SectionLayout_usage__3UYFQ","review":"SectionLayout_review__1VOrN","usageTitle":"SectionLayout_usageTitle__JwsEx","reviewTitle":"SectionLayout_reviewTitle__fH0Xy","feature":"SectionLayout_feature__BzPeR","cost":"SectionLayout_cost__TAvfs","location":"SectionLayout_location__gQJks","reviewSection":"SectionLayout_reviewSection__XdIxy"};

/***/ }),

/***/ 65025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","placeArea":"AreaPlaceList_placeArea__Ym38i","placeAreaTitle":"AreaPlaceList_placeAreaTitle__YM15u","placeAreaListWrap":"AreaPlaceList_placeAreaListWrap__hvmYI","placeAreaList":"AreaPlaceList_placeAreaList__q2tcy","placeAreaListItem":"AreaPlaceList_placeAreaListItem__SX2RG"};

/***/ }),

/***/ 28908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","prefArea":"AreaPrefectureList_prefArea__521af","prefAreaTitle":"AreaPrefectureList_prefAreaTitle__1uvVS","prefAreaTitleText":"AreaPrefectureList_prefAreaTitleText__Y03fR","prefAreaTitleIcon":"AreaPrefectureList_prefAreaTitleIcon__Ngq2U","prefAreaListWrap":"AreaPrefectureList_prefAreaListWrap__FZPSo","prefAreaListWrapActive":"AreaPrefectureList_prefAreaListWrapActive__l30CF","prefAreaList":"AreaPrefectureList_prefAreaList__M_fuA","prefAreaListItem":"AreaPrefectureList_prefAreaListItem__vqAy9","prefAreaArrowImage":"AreaPrefectureList_prefAreaArrowImage__xUe3o","prefAreaArrowImageActive":"AreaPrefectureList_prefAreaArrowImageActive__uQh9E","accordionIcon":"AreaPrefectureList_accordionIcon__6BDIB"};

/***/ }),

/***/ 59175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","title":"LocationSection_title__mwFxh","locationsItems":"LocationSection_locationsItems__aK1lh","locationsItemsCountryTwn":"LocationSection_locationsItemsCountryTwn__r4g7G","item":"LocationSection_item__XvVfg","itemOverlay":"LocationSection_itemOverlay__DlRwg","areaItems":"LocationSection_areaItems__LYhUH","areaItem":"LocationSection_areaItem__qoUhi","areaItemsCountryTwn":"LocationSection_areaItemsCountryTwn__6Iky7","areaItemsWrap":"LocationSection_areaItemsWrap__Ky28b","areaItemsWrapSelected":"LocationSection_areaItemsWrapSelected__MAcDA","selectedArea":"LocationSection_selectedArea__5Goum","backList":"LocationSection_backList__xTUPP","btnBack":"LocationSection_btnBack__B5DYn","areaName":"LocationSection_areaName___RVV_","areaNameLink":"LocationSection_areaNameLink__wVkjL","stationsContent":"LocationSection_stationsContent__ez_gL","selectedAreaWrap":"LocationSection_selectedAreaWrap__qnFzT","selectedAreaWrapSelected":"LocationSection_selectedAreaWrapSelected__8Mhe3","prefectures":"LocationSection_prefectures__Vr7BB","prefecturesSelected":"LocationSection_prefecturesSelected__D4aYX","gridLocationContainer":"LocationSection_gridLocationContainer__RRRyN","location":"LocationSection_location__20Eec","area":"LocationSection_area__sXYkR","cityContainer":"LocationSection_cityContainer__Xfitf","city":"LocationSection_city___QqQT"};

/***/ })

}]);